import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import Button from '../../../../components/Button';
import StepProgress from '../../../../components/StepProgress';
import Accordion from '../../../../components/Accordion';
import steps from '../../../../utils/steps.json';
import Modal from '../../../../components/Modal';
import SearchContainer from '../../../../components/SearchContainer';
import DataTableMui from '../../../../components/DataTableMui';

import {
    buscaBeneficiarioDesligar,
    movimentacoesPendentes,
    buscaDadosPorContrato,
} from '../../../../services';

import { addMaskCpf } from '../../../../utils';

import { useGlobal } from '../../../../contexts/Global/context';

import { ContainerDataTable, PageContainer } from '../../../../styles/styles';

function Selecionar() {
    const history = useHistory();

    const { dataActiveContract } = useGlobal();

    const emptyMessage = 'Não encontramos esse beneficiário. Você pode fazer uma nova pesquisa.';

    const [loading, setLoading] = useState(false);
    const [alreadySearched, setAlreadySearched] = useState(false);
    const [beneficiarios, setBeneficiarios] = useState([]);
    const [motivosDesligamento, setMotivosDesligamento] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');

    async function handleSearch(value) {
        setAlreadySearched(false);

        let response = {};
        let treatedResponse = [];

        if (value) {
            setLoading(true);

            response = (await buscaBeneficiarioDesligar(value.trim(), dataActiveContract.numero)) || {
                beneficiarios: [],
            };

            treatedResponse = response.beneficiarios?.map((element, index) => ({
                index,
                ...element,
                cpf: addMaskCpf(element.cpf),
            }));
        }

        setBeneficiarios(treatedResponse);

        setMotivosDesligamento(
            response.motivosExclusao?.filter((motivo) => !['RN 412', 'RN412', 'RN 432', 'RN432'].includes(motivo.nome))
        );

        setLoading(false);

        setAlreadySearched(true);
    }

    const columnsHead = [
        {
            key: 'numCarteirinha',
            selector: (row) => row.carteirinha || '-',
            name: 'Nº da carteirinha',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '200px' }),
        },
        {
            key: 'nomeCompleto',
            selector: (row) => row.nomeCompleto || '-',
            name: 'Nome completo',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: 'calc(100% - 600px)', height: '60px' }),
        },
        {
            key: 'cpf',
            selector: (row) => row.cpf || '-',
            name: 'CPF',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '200px' }),
        },
        {
            key: 'tipoOperacao',
            selector: (row) => row.tipo,
            name: 'Tipo',
            sortable: true,
            direction: 'center',
            customStyles: () => ({ width: '200px' }),
        },
    ];

    async function handleClickRow(row) {
        const dadosContrato = (await buscaDadosPorContrato(row.contrato.numero)) || {};
        const resumoContratoUpdate = dadosContrato.results[0];
        const tipoBeneficiario = row.tipo;

        const responsePendentes = await movimentacoesPendentes({
            numContrato: row.contrato.numero,
            offset: 0,
            limit: 1000,
        });

        const excluidosTotal = responsePendentes.filter(({ operacao }) => operacao === 7);
        const pendenciasDesligamento = excluidosTotal.filter(
            ({ status }) =>
                status === 3 ||
                status === 4 ||
                status === 6 ||
                status === 7 ||
                status === 8 ||
                status === 12 ||
                status === 13 ||
                status === 14 ||
                status === 15 ||
                status === 16 ||
                status === 18 ||
                status === 19
        );

        const vidasAtivasTitular = resumoContratoUpdate.quantidadeTitularesAtivos - pendenciasDesligamento.length;

        if (vidasAtivasTitular < 2 && dataActiveContract.isAdesao === false && tipoBeneficiario === 'TITULAR') {
            setModalMessage(
                'Entre em contato com quem gerencia a sua conta no GNDI para desligar o último beneficiário.'
            );

            setShowModal(true);

            return;
        }

        row.dataFimVigencia = dataActiveContract.dataFimVigencia;
        row.exigeTermoContributario = dataActiveContract.exigeTermoContributario;

        history.push({
            pathname: '/movimentacao_cadastral/desligar_beneficiario',
            dataBeneficiario: { ...row, motivosDesligamento },
        });
    }

    const rowMutation = {
        click: (row) => {
            handleClickRow(row);
        },
        hasClick: () => true,
    };

    return (
        <>
            <PageContainer>
                <StepProgress steps={steps.desligarBeneficiario} activeStep={1} />

                <Accordion title="Pesquisar beneficiário" hasCollapse={false}>
                    <SearchContainer
                        field={{
                            id: 'searchField',
                            label: 'Digite o nº da carteirinha, nome ou CPF',
                            required: true,
                        }}
                        disabled={loading}
                        onSearch={handleSearch}
                    />
                </Accordion>
            </PageContainer>

            <ContainerDataTable>
                <DataTableMui
                    clickableRow
                    rowMutation={rowMutation}
                    data={beneficiarios}
                    emptyMessage={emptyMessage}
                    loading={loading}
                    columns={columnsHead}
                    alreadySearched={alreadySearched}
                    firstOrderBy="numCarteirinha"
                />
            </ContainerDataTable>

            <Modal
                title="Atenção"
                subtitle={modalMessage}
                visible={showModal}
                onCancel={() => setShowModal(false)}
                footer={null}
            >
                <Button onClick={() => setShowModal(false)}>Entendi</Button>
            </Modal>
        </>
    );
}

export default Selecionar;
